import { h } from 'preact';
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import { EMBED_CLOSED } from '../../../../../types';
import { useOpenDialogsCounter, useRegisterDialog } from '../../../../common/context/DialogContext';
import { useNewStore, usePlayerContext, useStyles } from '../../../../common/hooks';
import { withBreakPoints } from '../../../hoc';
import { handleCloseModalButton } from '../../../utils/modal';
import Button from '../../common/buttons/Button';
import { Modal } from '../../common/modal';
import { MODAL_BASIC_STYLE, MODAL_CLOSING_BUTTON_STYLE } from '../../common/modal/types';
import { ModalWrapper } from '../../common/modal/wrapper';
import EmbedScreen from './EmbedScreen';
import {
  EMBED_DEFAULT_DIALOG_STYLE,
  EMBED_DIALOG_CONTENT_OPENED_STYLE,
  EMBED_DIALOG_CONTENT_STYLE
} from './styles';

const style = {
  container: EMBED_DEFAULT_DIALOG_STYLE,
  content: EMBED_DIALOG_CONTENT_STYLE,
  openedContent: EMBED_DIALOG_CONTENT_OPENED_STYLE
};

function EmbedButton({
  small,
  extraSmall,
  size,
  hidden
}) {
  const player = usePlayerContext();
  const { embedKey, controlIconSize } = useNewStore('ui', player);

  const [copied, setCopied] = useState(false);
  const [opened, setOpened] = useState(false);
  const [isOutsideModal, setIsOutsideModal] = useState(null);
  const closeIconRef = useRef(null);
  const iconRef = useRef(null);
  const setStyles = useStyles();

  useRegisterDialog({ id: 'embed', openingMode: 'click', state: [opened, setOpened] });
  useOpenDialogsCounter(opened);

  const embedKeyFetched = useRef(false);
  const fetchEmbedKey = useCallback(() => {
    if (!embedKeyFetched.current) {
      player.requestEmbed();
      embedKeyFetched.current = true;
    }
  }, [embedKeyFetched.current, embedKey]);

  useEffect(() => {
    if (!embedKey) {
      embedKeyFetched.current = false;
    }
  }, [embedKey]);

  useEffect(() => {
    if (opened && closeIconRef.current) {
      setIsOutsideModal(false);
      closeIconRef.current.focus();
    }

    if (!opened) {
      setCopied(false);
    }
  }, [opened, isOutsideModal]);

  const handleCloseModal = (event) => {
    handleCloseModalButton({
      event,
      player,
      currentIconRef: iconRef.current,
      setIsModalOpened: setOpened,
      closedAction: EMBED_CLOSED
    });
  };

  return !hidden && (
    <ModalWrapper wrapperCssClasses="ftv-magneto--glass-wrapper">
      <Button
        enableBackground
        hidden={hidden}
        type="icon"
        label="Intégrer"
        ariaLabel="Intégrer"
        forceLabel
        name="btn-embed"
        openingMode="click"
        icon="embed"
        style={style}
        size={size}
        xs={(small || extraSmall)}
        onClick={() => { fetchEmbedKey(); setOpened(true); }}
        iconRef={iconRef}
        zone="top"
      />

      {opened && (
        <Modal
          trap
          show={opened}
          attachedTo="btn-embed"
          styles={MODAL_BASIC_STYLE}
          onChange={(openedState) => {
            setIsOutsideModal(true);
            setOpened(openedState);
          }}
          onEscapeKeyDown={handleCloseModal}
          closingButtonStyle={setStyles(MODAL_CLOSING_BUTTON_STYLE)}
          closeComponent={(
            <Button
              type="icon"
              openingMode="click"
              label="Fermer"
              ariaLabel="Fermer"
              forceLabel
              disableFocus={false}
              zone="bottom"
              onClick={handleCloseModal}
              size={controlIconSize}
              icon="close"
              xs
              iconRef={closeIconRef}
              name="btn-close-embed"
              ariaHidden={false}
              last
            />
          )}
        >
          <EmbedScreen onCopyFail={() => { setOpened(false); }} copyEmbedIframe={() => setCopied(true)} copied={copied} />
        </Modal>
      )}
    </ModalWrapper>
  );
}

export default withBreakPoints(EmbedButton);
